import Model from "../../classes/model/Model";
import qs from "qs";
import User from "@/models/v2/User";

/**
 * @property {int} id
 * @property {int} task_id
 * @property {string} comment
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Client} schedule
 * @property {Client} schedule
 * @property {User} responsible
 * @property {User} creator
 * @property {User} updater
 */
export default class TaskComment extends Model {

    relations() {
        return {
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(taskId) {

        return TaskComment.getAxios().get(TaskComment.getUrl('task/get-comments'), {
            params: {
                id: taskId,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let comment of response.data) {
                data.push(new TaskComment(comment));
            }
            return {data, headers: response.headers};
        });
    }

    static create(taskId, comment) {

        return this.getAxios().post(this.getUrl('task/add-comment'), {
            id: taskId,
            comment: comment,
        }).then(() => {
            return true;
        });
    }
}
